import React from 'react';
import { ColorPicker } from 'antd';
import '../../LayerProperties.scss';

interface ColorFieldProps {
  value: string;
  onChange: (hex: string) => void;
}

/**
 * Figma-matching colour input: the hex value on the left and the colour swatch
 * on the right, inside a single bordered field that opens the colour picker.
 * (AntD's `showText` puts the swatch on the left, which doesn't match the
 * design, so we use a custom trigger.)
 */
const ColorField: React.FC<ColorFieldProps> = ({ value, onChange }) => (
  <ColorPicker value={value} disabledAlpha onChange={(c) => onChange(c.toHexString())}>
    <button type="button" className="lp-color-field">
      <span className="lp-color-field__hex">{value}</span>
      <span className="lp-color-field__swatch" style={{ backgroundColor: value }} />
    </button>
  </ColorPicker>
);

export default ColorField;
